export function checkComplexity(plainPassword: string): string[] {
  const errors: string[] = [];
  if (plainPassword.length < 8) errors.push('Password must be at least 8 characters long.');
  // more rules here;

  return errors;
}

export function checkPassword(password: string): string[] {
  const errors: string[] = [];
  if (password.length < 8) errors.push('Must be at least 8 characters long.');
  if (!/[A-Z]/.test(password)) errors.push('Must contain at least one uppercase letter.');
  if (!/[a-z]/.test(password)) errors.push('Must contain at least one lowercase letter.');
  if (!/[0-9]/.test(password)) errors.push('Must contain at least one digit.');
  if (!/[^A-Za-z0-9]/.test(password)) errors.push('Must contain at least one special character.');
  return errors;
}
